import angular from 'angular';

angular.module('myConsultApp').directive('inputSelectMultiple', () => {
  return {
    templateUrl: 'templates/v2/input-select-multiple.html',
    restrict: 'E',
    scope: {
      id: '@',
      nextFn: '&',
      searchFn: '&',
      onSelect: '&',
      keyField: '@',
      titleField: '@',
      valueField: '@',
      preselected: '=',
      blankValue: '=',
    },
    link: ($scope, elem) => {
      $scope.records = [];
      $scope.meta = {};
      $scope.scrollList = null;
      $scope.selected = [];

      $scope.matchPreselected = () => {
        $scope.selected = [];
        angular.forEach($scope.records, (option, key) => {
          if (
            $scope.preselected != undefined &&
            $scope.preselected.length > 0 &&
            $scope.preselected.includes(option[$scope.valueField])
          ) {
            $scope.selected.push(true);
          } else {
            $scope.selected.push(false);
          }
        });
      };

      $scope.getData = async () => {
        if ($scope.searchFn) {
          await $scope.searchFn().then((res) => {
            $scope.$apply(() => {
              $scope.records = res[$scope.keyField];
              $scope.meta = res.meta;
            });
          });
        }
        $scope.scrollList = $(elem).find('.multiple-select-options');
        $scope.scrollMonitor();
        $scope.matchPreselected();
      };

      $scope.selectOption = (option, index) => {
        $scope.selected[index] = !$scope.selected[index];
        option.state = $scope.selected[index];
        $scope.onSelect({ option });
      };

      $scope.scrollMonitor = () => {
        $scope.scrollList.scroll((event) => {
          const scroll = $scope.scrollList.scrollTop();
          const scrollHeight =
            elem.find('.select-option').outerHeight() * (elem.find('.select-option').length - 10);

          if ($scope.meta.next && scroll >= scrollHeight) {
            $scope.nextFn({ query: $scope.meta.next }).then((res) => {
              $scope.$apply(() => {
                $scope.records = [...$scope.records, ...res[$scope.keyField]];
                $scope.meta = res.meta;
              });
            });
          }
        });
      };

      $scope.$watch('preselected', () => {
        $scope.matchPreselected();
      });

      $scope.getData();
    },
  };
});
